import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'

import {BASE_CLASS} from '../../config/index.js'

export default function ModalButtons({
  buttons = {confirmButton: {}, cancelButton: {}},
  buttonsContent,
  forceInlineButtons = false,
  handleCancelButton = () => {},
  handleConfirmButton = () => {}
}) {
  const isHigherThanTabletResolution = useMediaQuery(useMediaQueryBreakpoints.lg)

  const {confirmButton, cancelButton} = buttons

  const hasCancelButton = Boolean(cancelButton && cancelButton.text)
  const hasConfirmButton = Boolean(confirmButton && confirmButton.text)

  const isFullWidth = hasCancelButton && hasConfirmButton && (!forceInlineButtons || isHigherThanTabletResolution)

  const defaultCancelButtonDesign = hasConfirmButton ? atomButtonDesigns.FLAT : atomButtonDesigns.SOLID

  return (
    <div className={cx(`${BASE_CLASS}-buttonsWrapper`, !isFullWidth && `${BASE_CLASS}-buttonsWrapper--inline`)}>
      {buttonsContent !== null && <div className={`${BASE_CLASS}-footerText`}>{buttonsContent}</div>}
      <div
        className={cx(
          `${BASE_CLASS}-buttons`,
          isFullWidth && `${BASE_CLASS}-buttons--fullWidth`,
          !isHigherThanTabletResolution && forceInlineButtons && `${BASE_CLASS}-buttons--inline`
        )}
      >
        {hasCancelButton && (
          <AtomButton
            color={cancelButton.color || atomButtonColors.PRIMARY}
            design={cancelButton.design ? cancelButton.design : defaultCancelButtonDesign}
            disabled={cancelButton.isDisabled}
            fullWidth={!isHigherThanTabletResolution || isFullWidth}
            isLoading={cancelButton.isLoading}
            shape={atomButtonShapes.CIRCULAR}
            size={atomButtonSizes.MEDIUM}
            onClick={handleCancelButton}
            type={cancelButton.type}
          >
            {cancelButton.text}
          </AtomButton>
        )}
        {hasConfirmButton && (
          <AtomButton
            color={confirmButton.color || atomButtonColors.PRIMARY}
            design={atomButtonDesigns.SOLID}
            disabled={confirmButton.isDisabled}
            fullWidth={!isHigherThanTabletResolution || isFullWidth}
            isFitted={!isHigherThanTabletResolution}
            isLoading={confirmButton.isLoading}
            shape={atomButtonShapes.CIRCULAR}
            size={atomButtonSizes.MEDIUM}
            onClick={handleConfirmButton}
            type={confirmButton.type}
          >
            {confirmButton.text}
          </AtomButton>
        )}
      </div>
    </div>
  )
}

ModalButtons.displayName = 'ModalButtons'
ModalButtons.propTypes = {
  buttons: PropTypes.shape({
    confirmButton: {
      color: PropTypes.string,
      customCallBack: PropTypes.func,
      isDisabled: PropTypes.bool,
      text: PropTypes.string,
      type: PropTypes.string
    },
    cancelButton: {
      color: PropTypes.string,
      customCallBack: PropTypes.func,
      isDisabled: PropTypes.bool,
      text: PropTypes.string,
      type: PropTypes.string
    }
  }),
  buttonsContent: PropTypes.node,
  forceInlineButtons: PropTypes.bool,
  handleCancelButton: PropTypes.func,
  handleConfirmButton: PropTypes.func
}
